import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Homepage from './pages/homepage/homepage'
import './App.css';
import ServicesPage from './pages/servicesPage/servicesPage';
import EquipamentsPage from './pages/equipamentsPage/equipamentsPage';
import DescribeEquipamentPage from './pages/describeEquipamentPage/describeEquipamentPage';
import ApplicationsPage from './pages/applicationsPage/applicationsPage';
import AboutUsPage from './pages/aboutUsPage/aboutUsPage';
import { SelectedLanguageContext, SelectedEquipamentContext } from './contexts/siteContentsContext';
import { useState } from 'react';

function App() {
  const [selectedEquipament, setSelectedEquipament] = useState("");
  const languageSettings = JSON.parse(localStorage.getItem("languageSettings")) 
  const [selectedLanguage, setSelectedLanguage] = useState( languageSettings ? languageSettings :
    {
      srcLanguageFile: "/siteData/contentPT-BR.json",
      srcIcon: "/languageIcons/brazil.png",
      name: "pt-br",
      nameCompletName: "Português",
      alt: "língua selecionda - Português"
    }
  );
  

  return (
    <div className="App">
      <SelectedEquipamentContext.Provider value={{selectedEquipament, setSelectedEquipament}}>
      <SelectedLanguageContext.Provider value={{selectedLanguage, setSelectedLanguage}}>
        
        <Router>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/services" element={<ServicesPage/>} />
            <Route path="/equipaments" element={<EquipamentsPage/>} />
            <Route path={ "equipaments/:id" + selectedEquipament.name } element={<DescribeEquipamentPage equipament={selectedEquipament}/>} />
            <Route path="/applications" element={<ApplicationsPage/>} />
            <Route path="/aboutUs" element={<AboutUsPage/>} />
          </Routes>
        </Router>
        
        </SelectedLanguageContext.Provider>
        </SelectedEquipamentContext.Provider>
        </div>
  );
}

export default App;
